<template>
  <span>
    <span v-if="Array.isArray(input)">[</span>
    <span v-else>{</span>
    <span v-if="!open" class="collapsed" @click="toggleSelf(parentKey)">&#183; &#183; &#183;</span>
    <ul v-else :class="{ array: Array.isArray(input) }">
      <li v-for="(val, key) in input" :key="val+key">
        <!-- <i class="mdi mdi-power"></i> -->

        <span v-if="childIsFolder(val)" class="folder" :class="{ opened: isChildOpen(key) } ">
          <ins @click="toggleChild(key)"><span class="key">"{{ key }}":&nbsp;</span></ins>
          <json :input="val" :open="isChildOpen(key)" :parentKey="key" @open="toggleChild"></json>
        </span>

        <span v-else-if="childIsString(val)" class="plain">
          <span class="key">"{{ key }}": </span><span class="value string"> "{{ val }}",</span>
        </span>

        <span v-else class="plain">
          <span class="key">"{{ key }}": </span><span class="value"> {{ val }},</span>
        </span>
      </li>
    </ul>
    <span v-if="Array.isArray(input)">]</span>
    <span v-else>}</span>
    <span v-if="parentKey">,</span>
  </span>
</template>

<script>
export default {
  name: 'json',
  data() {
    return {
      openedClildren: [],
    };
  },
  props: {
    input: {
      validator: () => true,
    },
    open: {
      type: Boolean,
      default: true,
    },
    parentKey: {
      type: [String, Number, undefined],
    },
  },
  methods: {
    toggleSelf(key) {
      this.$emit('open', key);
    },

    childIsFolder(value) {
      return value !== null && typeof value === 'object';
    },

    childIsString(value) {
      return typeof value === 'string';
    },

    toggleChild(key) {
      if (this.isChildOpen(key)) {
        this.openedClildren = this.openedClildren.filter(k => k !== key);
        return;
      }
      this.openedClildren.push(key);
    },

    isChildOpen(key) {
      return this.openedClildren.includes(key);
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0 0 0 2em;
  line-height: 1.7rem;
}

ul.array > li > .folder > ins > .key,
ul.array > li > .plain > .key {
  display: none;
}

li {
  list-style: none;
}

.collapsed {
  font-weight: bold;
  cursor: pointer;
}

.folder > ins {
  cursor: pointer;
  position: relative;
  text-decoration: none;
}

.folder > ins::before {
  font-family: 'Material Design Icons';
  text-rendering: auto;
  position: absolute;
  left: -1.4rem;
  content: '\F703';
}

.folder.opened > ins::before {
  content: '\F6F1';
}

.plain {
  display: flex;
}

.plain span {
  white-space: pre;
}

.value {
  color: #aa573c;
}

.value.string {
  color: #2a9292;
}
</style>



// WEBPACK FOOTER //
// src/components/Json.vue